import React from "react";
import GlassCard from "../../components/GlassCard";
import { userProfilePageContent } from "../data/userProfilePageContent";
import { useCurrentLang } from "../../hooks/useCurrentLang";
import { useState } from "react";
import { useAuth } from "../../auth";
const BasicInfoBox = () =>{
    const {user, userId} = useAuth();

    const [isEditing, setIsEditing] = useState(false);
    
    
    const currentLang = useCurrentLang()
    const t = userProfilePageContent[currentLang]
    return(
        <GlassCard style={{padding: "10px", maxWidth:"775px", marginLeft: "50px"}}>
            <div className="profile-section header-section">
            <div className="profile-col profile-col-left">
                <div className="profile-main-name" style={{paddingTop: "10px"}}>{user.name}</div>
                <div style={{textAlign: "start"}}><div className="profile-main-username">{user.username}</div>
                <div className="profile-main-sex">{user.sex || "Not set"}</div></div>
            </div>

            <div className="profile-col profile-col-right header-right">
                <div className="header-streak-box">
                <div className="header-calendar-icon">
                    <span className="header-calendar-day">
                    11
                    </span>
                </div>

                </div>
                <div className="header-joined">
                {t.join} {user.created_at}
                </div>
                <div
                className={
                    'header-status ' +
                    (user.is_active === 'ACTIVE' ? 'status-active' : 'status-inactive')
                }
                >
                {user.is_active}
                </div>
            </div>
            </div>
        </GlassCard>
    );
};
export default BasicInfoBox;